module.exports = __webpack_public_path__ + "img/block2-1.a1751604.webp";